import { Switch } from 'antd-mobile';

import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData, updateUrlParam } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import { MemberDiscount } from 'src/common/member-discount/MemberDiscount';

import OfficialPage from '../OfficialPage';

import './PreviewGroupOrder.less';

let dateTrans = {
  date: (a) => {
    var reg = new RegExp("-", "img");
    var c = a.replace(reg, '月') + '日';
    return c
  },
  week: (a) => {
    switch (a) {
      case '0':
        return '日';
      case '1':
        return '一';
      case '2':
        return '二';
      case '3':
        return '三';
      case '4':
        return '四';
      case '5':
        return '五';
      case '6':
        return '六';
    }
  }
}

export default class PreviewGroupOrder extends OfficialPage {
  state = {
    id: 0,
    selectmodel: '',
    order: {},
    formid: [],
    isFrom: true,
    goodsInfo: {},
    groupPrice: '',
    goodsPrice: '',
    kanfriends: [],
    cart_id_arr: [],
    kanprice: 0,
    description: '',
    num_of_people: 0,
    num: 0,
    status: 'P',
    storeConfig: '',
    express_fee: 0,
    box_fee: 0,
    selectAddress: '',
    shop: {
      id: '0'
    },
    exchangeCouponData: {
      dialogHidden: true,
      goodsInfo: {},
      selectModelInfo: {},
      hasSelectGoods: false,
      voucher_coupon_goods_info: {}
    },
    useBalance: true,
    selectDiscountInfo: {},
    cashOnDelivery: false,
    is_self_delivery: 0,
    deliverytype: 'express',
    noAdditionalInfo: true,
    additional_info_obj: {},
    goodsType: '',
    selectDelivery: '',
    pickUpType: '',
    expressAddressNull: false,
    additional_info: {},
    payGiftOptions: {}, // 支付有礼计算金额参数
    settlementActivityFreePrice: 0
  }

  memberDiscountRef = React.createRef();

  constructor(props) {
    super(props);
    document.title = '确认订单';
    // WEBAPP: 处理后一个页面回来的回调
    if (app.getCurrentPage().callbackData) {
      this.currentPage = app.getCurrentPage();
    }
  }

  // WEBAPP: 处理后一个页面回来的回调
  handleCurrentPage() {
    if (!this.currentPage) {
      return;
    }
    const { callbackData } = this.currentPage;
    if (callbackData) {
      this.setData(callbackData);
      this.currentPage.clearCallbackData();
      if (this.currentPage.additional_info) {
        this.additional_info = this.currentPage.additional_info;
        delete this.currentPage.additional_info;
      }
      if (this.currentPage.hasRequiredSuppInfo) {
        this.hasRequiredSuppInfo = this.currentPage.hasRequiredSuppInfo;
        delete this.currentPage.hasRequiredSuppInfo;
      }
    }
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    var that = this,
      selectmodelObj = JSON.parse(options.selectmodel),
      goods_id = options.goodsid,
      activityid = options.activityid,
      addressId = options.addressId || '',
      pickUpType = options.type || '',
      team_token = options.team_token || '',
      groupType = options.groupType,
      limit_buy = options.limit_buy,
      model_id = selectmodelObj.modelId || '',
      isFrom = options.isFrom,
      selectmodel = selectmodelObj.models_text,
      session_key = app.getStorageSync('session_key')
    this.cart_id_arr = options.cart_arr
      ? decodeURIComponent(options.cart_arr).split(',')
      : []
    this.franchisee_id = options.franchisee || ''
    this.setData({
      selectmodel: selectmodel,
      team_token: team_token,
      model_id: model_id,
      goods_id: goods_id,
      activityid: activityid,
      num_of_people: options.group_buy_people,
      num: Number(options.num),
      limit_buy: limit_buy,
      isFrom: isFrom,
      groupType: groupType,
      pickUpType: pickUpType,
      sameJourneyTimeType: pickUpType == 2 ? 1 : '',
      selectSameJourneyId: pickUpType == 2 ? addressId : '',
      selectAddressId: pickUpType == 1 ? addressId : '',
      phone: app.getUserInfo().phone,
      parentAppId: options.parent_app_id || ''
    })
    this.getLocation()
    setTimeout(function () {
      that.selectPickMethod('first')
    }, 500)
    // WEBAPP特殊处理(这里是有问题的，待解决)
    setTimeout(() => {
      this.handleCurrentPage()
    }, 0)
  }

  componentDidMount() {
    if (this.isFromSelectAddress) {
      this.getCalculationInfo()
      this.isFromSelectAddress = false
    }
  }

  getLocation = () => {
    let that = this,
      pickUpType = that.data.pickUpType
    app.getLocation({
      success: function (res) {
        if (!res.longitude) {
          return
        }
        app.sendRequest({
          url: '/index.php?r=Map/getAreaInfoByLatAndLng',
          data: {
            longitude: res.longitude,
            latitude: res.latitude
          },
          success: function (data) {
            that.setData({
              currentRegionId: data.data.region_id
            })
            if (pickUpType == 3) {
              that.getSelfDeliveryList()
            }
          }
        })
        that.setData({
          longitude: res.longitude,
          latitude: res.latitude
        })
      },
      fail: function (res) {
        console.log(res)
        app.addLog(res)
      }
    })
  }
  selectPickMethod = first => {
    let that = this
    let cartIdArr = this.cart_id_arr
    app.sendRequest({
      url: '/index.php?r=AppGroupBuy/getCanUsePickUpTypeAtAddOrder',
      method: 'post',
      data: {
        num: that.data.num,
        goods_id: that.data.goods_id,
        activity_id: that.data.activityid,
        model_id: that.data.model_id || '',
        num_of_people: that.data.num_of_people,
        team_token: that.data.team_token || '',
        latitude: that.data.latitude || '',
        longitude: that.data.longitude || '',
        region_id: that.data.currentRegionId || '',
        sub_shop_app_id: that.franchisee_id || ''
      },
      success: function (res) {
        // WEBAPP特殊处理: 设置 取货方式 参数
        updateUrlParam('type', 
          !that.data.pickUpType
            ? res.data.goods_pick_up_type_arr[0]
            : that.data.pickUpType
        )
        that.setData({
          pickUpTypeArr: res.data.goods_pick_up_type_arr,
          intraCityData: res.data.intra_city_data,
          isShowPickMask: first == 'first' ? false : true,
          pickUpType: !that.data.pickUpType
            ? res.data.goods_pick_up_type_arr[0]
            : that.data.pickUpType
        })
        if (first == 'first') {
          switch (that.data.pickUpType) {
            case '3':
              that.getSelfDeliveryList()
              break
            case '2':
              that.setData({
                sameJourneyTimeType: 1
              })
              break
          }
          that.getCalculationInfo()
        }
      }
    })
  }
  getGoodsStoreSet = type => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppEcommerce/getPickUpGoodsTypeSetting',
      data: {
        pick_up_type: type,
        sub_shop_app_id: this.franchisee_id
      },
      success: function (res) {
        let configData = res.data.config_data
        if (type == 3 && configData) {
          that.setData({
            selfAppointmentSwitch:
              configData.pick_up_time_status == 1 &&
                configData.appointment.status == 1
                ? true
                : false,
            onlyImmediatlyPickSwitch:
              configData.pick_up_time_status == 1 &&
                configData.appointment.status != 1 &&
                configData.immediate_info.self_pcik_up_status == 1
                ? true
                : false,
            selfDeliveryPhone: configData.is_phone,
            selfDeliveryScan:
              configData.pick_up_time_status == 1 &&
                configData.immediate_info.status == 1 &&
                configData.immediate_info.scan_qrcode_status == 1
                ? true
                : false
          })
          if (that.data.onlyImmediatlyPickSwitch) {
            that.showServiceTime('onlyImme')
          }
        } else if (type == 2 && configData) {
          that.getsameJourneyTime(configData.business_rule)
        }
      }
    })
  }
  tostoreImmediately = () => {
    this.setData({
      tostoreOrderType: 1,
      tostoreHourTime: '',
      isShowServiceTime: false
    })
  }
  selectTostoreTime = e => {
    let dateArr = this.data.getEcTostoredate.date_arr
    let index = e.currentTarget.dataset.index
    let tostoreDateTime = dateArr[index].date
    let tostoreWeekTime = dateArr[index].week
    this.setData({
      tostoreOrderType: 2,
      dateIndex: index,
      tostoreDateTime: tostoreDateTime,
      tostoreWeekTime: tostoreWeekTime,
      isShowServiceTime: this.data.tostoreTimeType != 1 ? true : false
    })
    this.getTostoreTime()
  }
  getTostoreTime = () => {
    let currentMonth = new Date().getMonth() + 1
    let currentMinute = new Date().getMinutes()
    let startHours = new Date().getHours()
    let currentDay = new Date().getDate()
    let currentDate =
      (currentMonth < 10 ? '0' + currentMonth : currentMonth) +
      '-' +
      (currentDay < 10 ? '0' + currentDay : currentDay)
    let tostoreHoursArr = []
    let currentLimitFlag = true
    let businessTimeRule = this.data.businessTimeRule
    let tostoreWeekTime = Number(this.data.tostoreWeekTime)
    let businessTime
    let showImmediatelyTime = this.businessTimeType == 1 ? true : false //1为全年 2为自定义
    let advanceAppointmentInfo = this.data.advanceAppointmentInfo
    let advanceTime =
      +advanceAppointmentInfo.num + startHours > 24
        ? +advanceAppointmentInfo.num + startHours - 24
        : +advanceAppointmentInfo.num + startHours
    this.businessTimeType == 2 &&
      businessTimeRule.map(item => {
        if (tostoreWeekTime == 0) {
          tostoreWeekTime = 7
        }
        if (item.business_week[tostoreWeekTime - 1] == 1) {
          businessTime = item.business_time_interval
        }
      })
    if (currentDate === this.data.tostoreDateTime) {
      if (this.businessTimeType == 2) {
        businessTime &&
          businessTime.map(item => {
            let fSH = startHours //是否要判断分钟，初始开始小时
            let fEH = Number(item.end_time.substring(0, 2)) //是否要判断分钟，初始结束小时
            let sH = Number(item.start_time.substring(0, 2))
            let eH = Number(item.end_time.substring(0, 2))
            let sT = Number(item.start_time.substring(3, 5))
            let eT = Number(item.end_time.substring(3, 5))
            if (startHours < advanceTime) {
              fSH = startHours = advanceTime
            }
            if (
              ((startHours > sH && startHours < eH) ||
                (startHours == sH && currentMinute >= sT)) &&
              !advanceTime
            ) {
              showImmediatelyTime = true
            }
            if (startHours < sH) {
              startHours = sH
              currentMinute = 0
            } else if (startHours > eH) {
              return
            }
            for (; startHours <= eH; startHours++) {
              if (this.data.tostoreTimeType == 2) {
                if (startHours == fEH) {
                  continue
                }
                tostoreHoursArr.push(
                  startHours + ':00-' + (startHours + 1) + ':00'
                )
              } else {
                if (
                  startHours == fSH &&
                  currentMinute <= 30 &&
                  currentMinute != 0
                ) {
                  tostoreHoursArr.push(
                    startHours + ':30-' + (startHours + 1) + ':00'
                  )
                  continue
                } else if (startHours == fSH && currentMinute > 30) {
                  continue
                } //开始分钟数大于三十分钟则跳过当前时间段
                if (startHours == fEH && eT >= 30) {
                  tostoreHoursArr.push(startHours + ':00-' + startHours + ':30')
                  continue
                } else if (startHours == fEH && eT == 0) {
                  continue
                } //结束分钟数等于0则跳过当前时间段
                tostoreHoursArr.push(startHours + ':00-' + startHours + ':30')
                tostoreHoursArr.push(
                  startHours + ':30-' + (startHours + 1) + ':00'
                )
              }
            }
          })
      } else {
        if (startHours < advanceTime) {
          startHours = advanceTime
        }
        for (; startHours < 24; startHours++) {
          if (this.data.tostoreTimeType == 2) {
            if (currentLimitFlag && currentMinute > 0) {
              currentLimitFlag = false
              startHours++
            }
            if (startHours >= 24) {
              continue
            }
            tostoreHoursArr.push(startHours + ':00-' + (startHours + 1) + ':00')
          } else {
            if (currentLimitFlag && currentMinute > 0 && currentMinute <= 30) {
              currentLimitFlag = false
              tostoreHoursArr.push(
                startHours + ':30-' + (startHours + 1) + ':00'
              )
              continue
            }
            if (currentLimitFlag && currentMinute > 30) {
              currentLimitFlag = false
              startHours++
            }
            if (startHours >= 24) {
              continue
            }
            tostoreHoursArr.push(startHours + ':00-' + startHours + ':30')
            tostoreHoursArr.push(startHours + ':30-' + (startHours + 1) + ':00')
          }
        }
      }
    } else {
      if (this.businessTimeType == 2) {
        businessTime &&
          businessTime.map(item => {
            let fSH = Number(item.start_time.substring(0, 2)) //是否要判断分钟，初始开始小时
            let fEH = Number(item.end_time.substring(0, 2)) //是否要判断分钟，初始结束小时
            let sH = Number(item.start_time.substring(0, 2))
            if (
              this.data.getEcTostoredate.date_arr[1].date ==
              this.data.tostoreDateTime &&
              sH < advanceTime &&
              +advanceAppointmentInfo.num + startHours > 24
            ) {
              sH = advanceTime
            }
            let eH = Number(item.end_time.substring(0, 2))
            let sT = Number(item.start_time.substring(3, 5))
            let eT = Number(item.end_time.substring(3, 5))
            for (; sH <= eH; sH++) {
              if (this.data.tostoreTimeType == 2) {
                if (sH == fEH || (sH == fSH && sT > 0)) {
                  continue
                }
                tostoreHoursArr.push(sH + ':00-' + (sH + 1) + ':00')
              } else {
                if (sH == fSH && sT <= 30 && sT != 0) {
                  tostoreHoursArr.push(sH + ':30-' + (sH + 1) + ':00')
                  continue
                } else if (sH == fSH && sT > 30) {
                  continue
                } //开始分钟数大于三十分钟则跳过当前时间段
                if (sH == fEH && eT <= 30 && eT != 0) {
                  tostoreHoursArr.push(sH + ':00-' + sH + ':30')
                  continue
                } else if (sH == fEH && eT == 0) {
                  continue
                } //结束分钟数等于0则跳过当前时间段
                tostoreHoursArr.push(sH + ':00-' + sH + ':30')
                tostoreHoursArr.push(sH + ':30-' + (sH + 1) + ':00')
              }
            }
          })
      } else {
        let i = 0
        if (
          this.data.getEcTostoredate.date_arr[1].date ==
          this.data.tostoreDateTime &&
          i < advanceTime &&
          +advanceAppointmentInfo.num + startHours > 24
        ) {
          i = advanceTime
        }
        for (; i < 24; i++) {
          if (this.data.tostoreTimeType == 2) {
            tostoreHoursArr.push(i + ':00-' + (i + 1) + ':00')
          } else {
            tostoreHoursArr.push(i + ':00-' + i + ':30')
            tostoreHoursArr.push(i + ':30-' + (i + 1) + ':00')
          }
        }
      }
    }
    this.setData({
      tostoreHoursArr: tostoreHoursArr,
      showImmediatelyTime: showImmediatelyTime
    })
  }
  selectTostoreHourTime = e => {
    let tostoreHoursArr = this.data.tostoreHoursArr
    let index = e.currentTarget.dataset.index
    let tostoreHourTime = tostoreHoursArr[index]
    this.setData({
      tostoreOrderType: 2,
      tostoreHourTime: tostoreHourTime,
      isShowServiceTime: false
    })
  }
  showSameJourneyTime = () => {
    if (!this.data.selectSameJourney.id) {
      app.showModal({
        content: '请先选择地址'
      })
      return
    }
    this.getGoodsStoreSet(2)
  }
  getsameJourneyTime = businessRule => {
    let sameJourneyHoursArr = []
    let currentMinute =
      new Date().getMinutes() + Number(this.data.sameJourneyImmediatlyTime)
    let startHours = new Date().getHours()
    if (currentMinute >= 60) {
      startHours++
      currentMinute = currentMinute - 60
    }
    if (businessRule.type == 1) {
      let currentLimitFlag = true
      for (; startHours < 24; startHours++) {
        if (currentLimitFlag && currentMinute > 0 && currentMinute <= 30) {
          currentLimitFlag = false
          sameJourneyHoursArr.push(startHours + ':30')
          continue
        }
        if (currentLimitFlag && currentMinute > 30) {
          currentLimitFlag = false
          startHours++
        }
        sameJourneyHoursArr.push(startHours + ':00')
        sameJourneyHoursArr.push(startHours + ':30')
      }
    } else {
      let currentWeek = new Date().getDay()
      let businessTime
      businessRule.type == 2 &&
        businessRule.custom.business_time.map(item => {
          if (currentWeek == 0) {
            currentWeek = 7
          }
          if (item.business_week[currentWeek - 1] == 1) {
            businessTime = item.business_time_interval
          }
        })
      businessTime.map(item => {
        let fSH = startHours //是否要判断分钟，初始开始小时
        let fEH = Number(item.end_time.substring(0, 2)) //是否要判断分钟，初始结束小时
        let sH = Number(item.start_time.substring(0, 2))
        let eH = Number(item.end_time.substring(0, 2))
        let sT = Number(item.start_time.substring(3, 5))
        let eT = Number(item.end_time.substring(3, 5))
        if (startHours <= sH) {
          startHours = sH
          currentMinute = 0
        } else if (startHours > eH) {
          return
        }
        for (; startHours <= eH; startHours++) {
          if (startHours == fSH && currentMinute <= 30 && currentMinute != 0) {
            sameJourneyHoursArr.push(startHours + ':30')
            continue
          } else if (startHours == fSH && currentMinute > 30) {
            continue
          } //开始分钟数大于三十分钟则跳过当前时间段
          if (startHours == fEH && eT < 30) {
            sameJourneyHoursArr.push(startHours + ':00')
            continue
          } else if (startHours == fEH && eT == 0) {
            continue
          } //结束分钟数等于0则跳过当前时间段
          sameJourneyHoursArr.push(startHours + ':00')
          sameJourneyHoursArr.push(startHours + ':30')
        }
      })
    }
    this.setData({
      sameJourneyHoursArr: sameJourneyHoursArr,
      isShowSameJourneyTime: true
    })
  }
  getAppECStoreConfig = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=appShop/getAppECStoreConfig',
      data: {
        sub_shop_app_id: that.franchisee_id || ''
      },
      success: function (res) {
        if (res.data.express == 0) {
          that.getSelfDeliveryList()
        }
        that.setData({
          storeConfig: res.data,
          is_self_delivery:
            res.data.express == 0 && res.data.is_self_delivery == 1 ? 1 : 0,
          storeStyle: that.franchisee_id ? '' : res.data.color_config
        })
        that.getCalculationInfo()
      }
    })
  }
  selectSameJourneyTime = e => {
    let type = e.currentTarget.dataset.type
    let sameJourneyHoursArr = this.data.sameJourneyHoursArr
    let index = e.currentTarget.dataset.index
    let sameJourneyDateTime = sameJourneyHoursArr[index]
    this.setData({
      sameJourneyTimeType: type == 'immedia' ? 1 : 2,
      sameJourneyDateTime: type == 'immedia' ? '' : sameJourneyDateTime,
      isShowSameJourneyTime: false
    })
  }
  deliveryWayChange = event => {
    let type = event.currentTarget.dataset.type
    // WEBAPP特殊处理: 设置 取货方式 参数
    updateUrlParam('type', type)
    if (type == 3) {
      this.getSelfDeliveryList()
    }
    this.setData({
      pickUpType: type,
      sameJourneyTimeType: type == 2 ? 1 : '',
      isShowPickMask: false,
      cashOnDelivery: false
    })
    this.getCalculationInfo()
  }
  getSelfDeliveryList = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/getSelfDeliveryList',
      data: {
        sub_shop_app_id: that.franchisee_id || ''
      },
      success: function (res) {
        let storeList = res.data.store_list_data
        if (!storeList) {
          app.showModal({
            content: '商家暂无自提门店',
            confirm: function () {
              app.turnBack()
            }
          })
          return
        }
        if (storeList.length == 1) {
          that.setData({
            selectDelivery: storeList[0]
          })
        }
        if (storeList.length >= 2 && !that.data.selectDelivery) {
          app.showModal({
            content: '当前尚未选择自提点',
            confirmText: '去设置',
            cancelText: '取消',
            showCancel: true,
            confirm: function () {
              that.toDeliveryList()
            }
          })
        }
        that.getGoodsStoreSet(3)
      }
    })
  }
  toDeliveryList = () => {
    let that = this
    let url = ''
    if (that.franchisee_id) {
      url += '?franchiseeId=' + that.franchisee_id
      url += that.data.selectDelivery.id
        ? '&deliveryId=' + that.data.selectDelivery.id
        : ''
    } else {
      url += that.data.selectDelivery.id
        ? '?deliveryId=' + that.data.selectDelivery.id
        : ''
    }
    that.saveUserFormId(function () {
      app.turnToPage(
        '/eCommerce/pages/goodsDeliveryList/goodsDeliveryList' + url
      )
    })
  }
  goToAdditionalInfo = () => {
    app.setGoodsAdditionalInfo(this.data.additional_info)
    this.saveUserFormId(function () {
      app.turnToPage('/eCommerce/pages/goodsAdditionalInfo/goodsAdditionalInfo')
    })
  }
  goToMyAddress = () => {
    var addressId = this.data.selectAddress && this.data.selectAddress.id
    this.isFromSelectAddress = true
    this.saveUserFormId(function () {
      app.turnToPage('/eCommerce/pages/myAddress/myAddress?id=' + addressId)
    })
  }
  clickMinusButton = e => {
    var index = e.currentTarget.dataset.index,
      num = this.data.num
    if (+num <= 0) return
    this.changeGoodsNum(index, 'minus')
  }
  inputBuyCount = e => {
    var count = +e.target.value,
      goodsInfo = this.data.goodsInfo,
      limit_buy = +this.data.limit_buy,
      stock = +goodsInfo.stock
    if (this.data.groupType != '4' && count > limit_buy && limit_buy != 0) {
      app.showModal({
        content:
          '已超过该商品的限购件数（每人限购' + this.data.limit_buy + '件）'
      })
      this.setData({
        num: limit_buy
      })
      return
    }
    if (count == 0) {
      this.setData({
        num: 1
      })
      return
    }
    if (count >= stock) {
      count = stock
      app.showModal({
        content: '购买数量不能大于库存'
      })
    }
    this.setData({
      num: +count
    })
    this.getCalculationInfo()
  }
  clickPlusButton = e => {
    var index = e.currentTarget.dataset.index,
      stock = +this.data.goodsInfo.stock,
      limit_buy = +this.data.limit_buy,
      num = this.data.num
    if (
      this.data.groupType != '4' &&
      limit_buy !== '' &&
      limit_buy != 0 &&
      +num >= limit_buy
    ) {
      app.showModal({
        content: '已超过该商品的限购件数（每人限购' + limit_buy + '件）'
      })
      this.setData({
        num: limit_buy
      })
      return
    }
    this.changeGoodsNum(index, 'plus')
  }
  changeGoodsNum = (index, type) => {
    var goods = this.data.goodsInfo,
      stock = +goods.stock,
      currentNum = this.data.num,
      targetNum =
        type == 'plus'
          ? currentNum + 1
          : type == 'minus'
            ? currentNum - 1
            : Number(type),
      that = this,
      data = {},
      param
    if (targetNum == 0 && type == 'minus') {
      this.setData({
        num: 1
      })
      return
    }
    if (targetNum > stock) {
      app.showModal({
        content: '购买数量不能大于库存'
      })
      this.setData({
        num: stock
      })
      return
    }
    this.setData({
      num: targetNum
    })
    this.getCalculationInfo()
  }
  getCalculationInfo = () => {
    var that = this,
      goods_id = that.data.goods_id,
      activity_id = that.data.activityid,
      model_id = that.data.model_id || '',
      tostoreOrderType = this.data.tostoreOrderType
    let year = new Date().getFullYear()
    let tostoreDateTime =
      year +
      '-' +
      this.data.tostoreDateTime +
      ' ' +
      (this.data.tostoreHourTime || '')
    app.sendRequest({
      url: '/index.php?r=appGroupBuy/calculatePrice',
      method: 'post',
      data: {
        goods_id: goods_id,
        activity_id: activity_id,
        pick_up_type: this.data.pickUpType,
        model_id: model_id || '',
        sub_shop_app_id: that.franchisee_id || '',
        address_id:
          this.data.pickUpType == 1
            ? this.data.selectAddressId
            : this.data.selectSameJourneyId,
        cart_id_arr: this.cart_id_arr,
        is_balance: this.data.useBalance ? 1 : 0,
        is_self_delivery: this.data.is_self_delivery,
        select_benefit: this.data.selectDiscountInfo,
        num_of_people: this.data.num_of_people,
        num: this.data.num,
        team_token: this.data.team_token || '',
        ecommerce_info: {
          ec_tostore_data: {
            ec_tostore_order_type: tostoreOrderType || 1,
            ec_tostore_appointment_time:
              tostoreOrderType == 1 || !this.data.selfAppointmentSwitch
                ? ''
                : tostoreDateTime,
            ec_tostore_buyer_phone: this.data.phone || '',
            ec_tostore_appointment_time_type: this.data.tostoreTimeType || '',
            ec_tostore_location_id: this.data.locationId || ''
          },
          intra_city_data: {
            intra_city_appointment_arrive_time:
              this.data.sameJourneyTimeType == 1
                ? ''
                : this.data.sameJourneyDateTime
          }
        },
        voucher_coupon_goods_info: this.data.exchangeCouponData
          .voucher_coupon_goods_info,
        settlement_activity_info: this.data.payGiftOptions
      },
      success: function (res) {
        if (typeof res.data == 'string') {
          if (!that.data.isFrom && res.data == '已达到抽奖机会购买上限') {
            app.showModal({
              content: res.data
            })
            that.setData({
              num: 1
            })
            return
          } else {
            app.showModal({
              content: res.data,
              confirm: function () {
                app.turnBack()
              }
            })
            return
          }
        }
        let info = res.data
        let benefits = info.benefit
        let goods_info = info.goods_info
        let additional_info_goods = []
        let selectDiscountInfo = info.select_benefit
        let suppInfoArr = []
        let additional_goodsid_arr = []
        if (
          that.data.pickUpType == 2 &&
          info.intra_city_status_data &&
          info.intra_city_status_data.in_distance == 0
        ) {
          app.showModal({
            content: '地址不在配送范围内',
            confirmText: '去更换',
            cancelText: '取消',
            showCancel: true,
            confirm: function () {
              that.goSameJourneyAddress()
            },
            cancel: function () {
              that.setData({
                selectSameJourney: ''
              })
            }
          })
          return
        }
        let goodsBenefitsData = [],
          goodsPrice =
            goods_info.virtual_price == '0.00'
              ? goods_info.original_price
              : goods_info.virtual_price,
          groupPrice = info.original_price
        benefits.coupon_benefit && benefits.coupon_benefit.length
          ? goodsBenefitsData.push({
            label: 'coupon',
            value: benefits.coupon_benefit
          })
          : ''
        benefits.all_vip_benefit && benefits.all_vip_benefit.length
          ? goodsBenefitsData.push({
            label: 'vip',
            value: benefits.all_vip_benefit
          })
          : ''
        Array.isArray(benefits.integral_benefit)
          ? ''
          : benefits.integral_benefit &&
          goodsBenefitsData.push({
            label: 'integral',
            value: [benefits.integral_benefit]
          })
        if (
          selectDiscountInfo.discount_type == 'coupon' &&
          selectDiscountInfo.type == 3 &&
          that.data.exchangeCouponData.hasSelectGoods == false
        ) {
          that.exchangeCouponInit(parseInt(selectDiscountInfo.value))
        }
        if (
          goods_info.delivery_id &&
          goods_info.delivery_id != 0 &&
          additional_goodsid_arr.indexOf(goods_info.id) == -1
        ) {
          suppInfoArr.push(goods_info.delivery_id)
          additional_goodsid_arr.push(goods_info.goods_id)
          additional_info_goods.push(goods_info)
        }
        let group_buy_price = String(
          info.original_price - info.group_buy_discount_price
        )
        if (group_buy_price.split('.')[1]) {
          group_buy_price = Number(group_buy_price).toFixed(2)
        }
        if (suppInfoArr.length && !that.data.deliverydWrite) {
          that.getSuppInfo(suppInfoArr)
        }
        if (+info.settlement_activity_item_price) {
          info.final_price = (
            +info.final_price + +info.settlement_activity_item_price
          ).toFixed(2)
        }
        that.setData({
          expressAddressNull: info.address
            ? false
            : that.data.expressAddressNull,
          goodsPrice: goodsPrice,
          groupPrice: groupPrice,
          goodsInfo: goods_info,
          isFrom: false,
          selectAddress: that.data.pickUpType == 1 && info.address,
          discountList: goodsBenefitsData,
          selectDiscountInfo: selectDiscountInfo,
          express_fee: info.express_fee,
          box_fee: info.box_fee,
          discount_price: info.discount_price,
          balance: info.balance,
          deduction: info.use_balance,
          original_price: info.original_price,
          group_buy_price: group_buy_price,
          totalPayment: info.final_price,
          canCashDelivery: info.is_pay_on_delivery || '',
          noAdditionalInfo: suppInfoArr.length ? false : true,
          cashOnDelivery: info.price > 0 ? that.data.cashOnDelivery : false,
          additional_goodsid_arr: additional_goodsid_arr,
          selectSameJourney: that.data.pickUpType == 2 && info.address,
          sameJourneyImmediatlyTime:
            (info.intra_city_status_data &&
              info.intra_city_status_data.deliver_time) ||
            '',
          settlementActivityFreePrice:
            info.settlement_activity_free_bills_item_price
        })
        app.setPreviewGoodsInfo(additional_info_goods)
      },
      fail: function () {
        app.turnBack()
      }
    })
  }
  closeGoodsPick = () => {
    this.setData({
      isShowPickMask: false,
      isShowServiceTime: false,
      isShowSameJourneyTime: false
    })
  }
  showServiceTime = type => {
    let deliveryData = this.data.selectDelivery
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppEcommerce/GetEcTostoreAppointmentDateList',
      data: {
        sub_shop_app_id: that.franchisee_id || '',
        self_delivery_app_store_id: deliveryData.id || ''
      },
      success: function (res) {
        let data = res.data
        if (type == 'onlyImme') {
          that.setData({
            waitingQueueTime: data.duration_time,
            tostoreOrderType: 1
          })
          return
        }
        let tostoreTimeType =
          data.setting_data.appointment.appointment_time_type //1为天 2为时 3为半小时
        let tostoreDateTime = ''
        let tostoreWeekTime = ''
        let dateArr = data.date_arr
        let advanceAppointmentInfo =
          data.setting_data.appointment.advance_appointment_info
        let startHours = new Date().getHours()
        let businessTimeRule = data.business_time_rule //上门自提营业时间
        let maxEndHour = 24
        let currentMinute = new Date().getMinutes()
        let showImmediatelyTime = false
        let noImmediaPick =
          data.setting_data.immediate_info.status == 1 &&
            advanceAppointmentInfo.type == 1
            ? true
            : false //判断上门自提立即取货开关开没开
        let noAppointmentShow = true //是否显示暂无营业时间
        if (businessTimeRule.type == 2) {
          //获取自定义当天营业时间的终止小时
          let week = dateArr[0].week
          let timeArr
          businessTimeRule.custom.business_time.map(item => {
            if (week == 0) {
              week = 7
            }
            if (item.business_week[week - 1] == 1) {
              timeArr = item.business_time_interval
              maxEndHour = +timeArr[timeArr.length - 1].end_time.substring(0, 2)
            }
          })
          timeArr &&
            timeArr.map(item => {
              let sH = Number(item.start_time.substring(0, 2))
              let eH = Number(item.end_time.substring(0, 2))
              let sT = Number(item.start_time.substring(3, 5))
              let eT = Number(item.end_time.substring(3, 5))
              if (
                (startHours > sH && startHours < eH) ||
                (startHours == sH && currentMinute >= sT)
              ) {
                showImmediatelyTime = true
              }
            })
        } else {
          showImmediatelyTime = true
        }
        for (let i = 0; i < dateArr.length; i++) {
          if (
            i == 0 &&
            ((advanceAppointmentInfo.type == 2 &&
              +advanceAppointmentInfo.num + startHours >= maxEndHour) ||
              (advanceAppointmentInfo.type == 1 && startHours >= maxEndHour))
          ) {
            dateArr[i].is_vaild = 0
          }
          if (dateArr[i].is_vaild == 1 && tostoreTimeType != 1) {
            tostoreDateTime = dateArr[i].date
            tostoreWeekTime = dateArr[i].week
            break
          }
        }
        dateArr.map(item => {
          if (item.is_vaild == 1) {
            noAppointmentShow = false
          }
        })
        that.businessTimeType = businessTimeRule.type
        that.setData({
          getEcTostoredate: data,
          waitingQueueTime: data.duration_time,
          tostoreTimeType: tostoreTimeType,
          isShowServiceTime: true,
          noImmediaPick: noImmediaPick,
          tostoreDateTime: that.data.tostoreDateTime
            ? that.data.tostoreDateTime
            : tostoreDateTime,
          tostoreWeekTime: that.data.tostoreWeekTime
            ? that.data.tostoreWeekTime
            : tostoreWeekTime,
          businessTimeRule:
            businessTimeRule.type == 1
              ? ''
              : businessTimeRule.custom.business_time,
          advanceAppointmentInfo: advanceAppointmentInfo,
          noAppointmentShow: noAppointmentShow,
          showImmediatelyTime: showImmediatelyTime
        })
        if (tostoreTimeType != 1) {
          that.getTostoreTime()
        }
        businessTimeRule.type == 2 && that.getNoAppointmentWord()
      }
    })
  }
  goSameJourneyAddress = e => {
    let selectSameJourney = this.data.selectSameJourney
    this.isFromSelectAddress = true
    app.turnToPage(
      '/eCommerce/pages/goodsSameJourney/goodsSameJourney?from=preview&sameJourneyId=' +
      (selectSameJourney ? selectSameJourney.id : '') +
      '&franchiseeId=' +
      this.franchisee_id
    )
  }
  commentChange = e => {
    var value = e.target.value
    if (value.length > 30) {
      app.showModal({
        content: '最多只能输入30个字'
      })
      value = value.slice(0, 30)
    }
    this.setData({
      description: value
    })
  }
  inputFormControl = e => {
    let a = this.data.additional_info
    let b = this.data.additional_goodsid_arr[0]
    a[b][0].value = e.target.value
    this.setData({
      additional_info: a
    })
  }
  getSuppInfo = suppInfoArr => {
    var that = this
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=pc/AppShop/GetDelivery',
      method: 'post',
      data: {
        delivery_ids: suppInfoArr,
        sub_shop_app_id: that.franchisee_id || ''
      },
      success: function (res) {
        for (let i = 0; i < res.data.length; i++) {
          let suppInfo = res.data[i].delivery_info
          for (let j = 0; j < suppInfo.length; j++) {
            if (suppInfo[j].is_required == 0 && suppInfo[j].is_hidden == 1) {
              that.setData({
                hasRequiredSuppInfo: true
              })
            }
          }
        } // 单商品单补充信息时直接展示
        if (
          res.data.length == 1 &&
          that.data.additional_goodsid_arr.length == 1
        ) {
          let deliveryIndex = 0
          let showIndex = 0
          res.data[0].delivery_info.map(item => {
            showIndex++
            if (item.is_hidden == 1) {
              deliveryIndex++
            }
          })
          if (deliveryIndex == 1) {
            let data = {}
            data[that.data.additional_goodsid_arr[0]] = []
            data[that.data.additional_goodsid_arr[0]].push({
              title: res.data[0].delivery_info[showIndex - 1].name,
              type: res.data[0].delivery_info[showIndex - 1].type,
              is_required: res.data[0].delivery_info[showIndex - 1].is_required,
              value: ''
            })
            that.setData({
              additional_info: data,
              aloneDeliveryShow: true
            })
          }
        }
      }
    })
  }
  confirmPayment = e => {
    let formid = this.data.formid,
      that = this,
      list = this.data.goodsList,
      tostoreOrderType = this.data.tostoreOrderType,
      select_benefit = this.data.selectDiscountInfo,
      hasWritedAdditionalInfo = false
    formid.push(e.target.formId)
    if (this.data.pickUpType == 1 && !this.data.selectAddress) {
      this.setData({
        expressAddressNull: true
      })
      return
    }
    if (this.data.pickUpType == 2 && !this.data.selectSameJourney) {
      app.showModal({
        content: '请完善地址信息',
        confirmText: '去填写',
        confirm: function () {
          that.goToMyAddress()
        }
      })
      return
    }
    if (this.data.pickUpType == 2 && !this.data.selectSameJourney) {
      app.showModal({
        content: '请选择同城地址',
        confirmText: '去填写',
        confirm: function () {
          that.goSameJourneyAddress()
        }
      })
      return
    }
    if (
      this.data.pickUpType == 2 &&
      !this.data.sameJourneyDateTime &&
      this.data.sameJourneyTimeType != 1
    ) {
      app.showModal({
        content: '请选择取货时间'
      })
      return
    }
    if (this.data.pickUpType == 3 && !this.data.selectDelivery) {
      app.showModal({
        content: '请选择上门自提地址',
        confirmText: '去填写',
        confirm: function () {
          that.toDeliveryList()
        }
      })
      return
    }
    for (var key in this.data.additional_info) {
      if (key !== undefined) {
        hasWritedAdditionalInfo = true
        break
      }
    }
    if (
      this.data.pickUpType == 3 &&
      this.data.selfAppointmentSwitch &&
      !tostoreOrderType
    ) {
      app.showModal({
        content: '请选择取货时间'
      })
      return
    }
    let year = new Date().getFullYear()
    let tostoreDateTime =
      year +
      '-' +
      this.data.tostoreDateTime +
      ' ' +
      (this.data.tostoreHourTime || '')
    if (
      this.data.pickUpType == 3 &&
      this.data.selfDeliveryPhone == 1 &&
      !util.isPhoneNumber(this.data.phone)
    ) {
      app.showModal({
        content: '请输入正确的手机号'
      })
      return
    }
    if (
      this.data.hasRequiredSuppInfo &&
      !this.data.deliverydWrite &&
      !this.data.aloneDeliveryShow
    ) {
      app.showModal({
        content: '商品补充信息未填写，无法进行支付',
        confirmText: '去填写',
        confirm: function () {
          that.goToAdditionalInfo()
        }
      })
      return
    }
    if (this.data.aloneDeliveryShow) {
      let a = this.data.additional_info
      let id = this.data.additional_goodsid_arr[0]
      if (a[id][0].is_required == 0 && a[id][0].value == '') {
        app.showModal({
          content: '请填写' + a[id][0].title,
          confirmText: '确认'
        })
        return
      }
    }
    if (this.requesting) {
      return
    }
    this.requesting = true
    var data = {}
    app.sendRequest({
      url: '/index.php?r=appGroupBuy/addOrder',
      method: 'post',
      data: {
        goods_id: that.data.goods_id,
        activity_id: that.data.activityid,
        sub_shop_app_id: that.franchisee_id || this.data.parentAppId || '',
        model_id: that.data.model_id || '',
        num: that.data.num,
        num_of_people: that.data.num_of_people,
        team_token: that.data.team_token || '',
        formId: e.target.formId,
        select_benefit: that.data.selectDiscountInfo,
        is_balance: that.data.useBalance ? 1 : 0,
        is_self_delivery: that.data.is_self_delivery,
        self_delivery_app_store_id:
          that.data.is_self_delivery == 1 ? that.data.selectDelivery.id : '',
        remark: that.data.description,
        address_id:
          this.data.pickUpType == 1
            ? this.data.selectAddress.id
            : this.data.selectSameJourney.id,
        is_pay_on_delivery: that.data.cashOnDelivery ? 1 : 0,
        additional_info: that.data.additional_info,
        express_fee: that.data.express_fee,
        box_fee: that.data.box_fee,
        ecommerce_info: {
          ec_tostore_data: {
            ec_tostore_order_type: tostoreOrderType || 1,
            ec_tostore_appointment_time:
              tostoreOrderType == 1 || !this.data.selfAppointmentSwitch
                ? ''
                : tostoreDateTime,
            ec_tostore_buyer_phone: this.data.phone || '',
            ec_tostore_appointment_time_type: this.data.tostoreTimeType || '',
            ec_tostore_location_id: this.data.locationId || ''
          },
          intra_city_data: {
            intra_city_appointment_arrive_time:
              this.data.sameJourneyTimeType == 1
                ? ''
                : this.data.sameJourneyDateTime
          }
        },
        pick_up_type: this.data.pickUpType,
        self_delivery_app_store_id:
          this.data.pickUpType == 3 ? this.data.selectDelivery.id : '',
        voucher_coupon_goods_info: this.data.exchangeCouponData
          .voucher_coupon_goods_info,
        settlement_activity_info: this.data.payGiftOptions
      },
      success: function (res) {
        var data = res.data
        if (res.status == 0) {
          if (that.data.cashOnDelivery) {
            let pagePath =
              '/group/pages/gppaySuccess/gppaySuccess?detail=' +
              res.data.order_id +
              (that.franchisee_id ? '&franchisee=' + that.franchisee_id : '') +
              '&is_group=' +
              !!that.is_group +
              '&orderid=' +
              res.data.order_id +
              '&teamToken=' +
              res.data.team_token
            that.saveUserFormId(function () {
              app.turnToPage(pagePath)
            })
          } else {
            that.payOrder(res.data.order_id, res.data.team_token)
          }
          that.setData({
            team_token: res.data.team_token
          })
        } else {
          app.showModal({
            content: res.data
          })
          return
        }
      },
      fail: function () {
        that.requesting = false
      },
      successStatusAbnormal: function () {
        that.requesting = false
      }
    })
  }
  additionInfo = orderId => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/info',
      data: {
        additional_info: that.data.additional_info,
        sub_shop_app_id: that.franchisee_id || '',
        order_id: orderId
      },
      success: function (res) { }
    })
  }
  payOrder = (orderId, teamToken) => {
    var that = this
    function paySuccess() {
      var pagePath =
        '/group/pages/gppaySuccess/gppaySuccess?detail=' +
        orderId +
        (that.franchisee_id ? '&franchisee=' + that.franchisee_id : '') +
        '&is_group=' +
        !!that.is_group +
        '&teamToken=' +
        teamToken
      if (!that.franchisee_id) {
        app.sendRequest({
          url: '/index.php?r=AppMarketing/CheckAppCollectmeStatus',
          data: {
            sub_shop_app_id: that.franchisee_id || '',
            order_id: orderId
          },
          success: function (res) {
            if (res.valid == 0) {
              pagePath += '&collectBenefit=1'
            }
            that.saveUserFormId(function () {
              app.turnToPage(pagePath, 1)
            })
          }
        })
      } else {
        that.saveUserFormId(function () {
          app.turnToPage(pagePath, 1)
        })
      }
    }
    function payFail() {
      app.sendRequest({
        url: '/index.php?r=appShop/cancelOrder',
        data: {
          sub_shop_app_id: that.franchisee_id || '',
          order_id: orderId
        },
        success: () => {
          app.turnBack()
        }
      })
    }
    if (this.data.totalPayment == 0) {
      app.sendRequest({
        url: '/index.php?r=AppShop/paygoods',
        data: {
          sub_shop_app_id: that.franchisee_id || '',
          order_id: orderId,
          total_price: 0
        },
        success: function (res) {
          paySuccess()
        },
        fail: function () {
          payFail(orderId)
        },
        successStatusAbnormal: function () {
          payFail(orderId)
        },
        successShowModalConfirm: function () {
          app.turnBack()
        }
      })
      return
    }
    // app.sendRequest({
    //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
    //   data: {
    //     sub_shop_app_id: that.franchisee_id || '',
    //     order_id: orderId
    //   },
    //   success: function (res) {
    //     var param = res.data
    //     param.orderId = orderId
    //     param.success = paySuccess
    //     param.goodsType = 0
    //     param.fail = payFail
    //     app.wxPay(param)
    //   },
    //   fail: function () {
    //     payFail()
    //   },
    //   successStatusAbnormal: function () {
    //     payFail()
    //   },
    //   successShowModalConfirm: function () {
    //     app.turnBack()
    //   }
    // })
    app.goPay({
      orderId: orderId,
      franchisee: that.franchisee_id,
      successUrl: 'gppaySuccess?detail=' + orderId + (that.franchisee_id ? '&franchisee=' + that.franchisee_id : '') + '&is_group=' + !!that.is_group + '&teamToken=' + teamToken,
      cancel: payFail
    })
  }
  showMemberDiscount = () => {
    this.memberDiscountRef.current.show({
      discountType: this.data.discountList,
      afterSelectedDiscount: (event) => {
        this.afterSelectedBenefit(event)
      }
    })
    this.memberDiscountRef.current.showDialog(this.data.selectDiscountInfo);
  }
  afterSelectedBenefit = ({selectedDiscount}) => {
    this.setData({
      selectDiscountInfo:
        selectedDiscount.name == '无'
          ? 'no_use_benefit'
          : selectedDiscount,
      'exchangeCouponData.hasSelectGoods': false,
      'exchangeCouponData.voucher_coupon_goods_info': {}
    })
    this.getCalculationInfo()
  }
  useBalanceChange = checked => {
    this.setData({
      useBalance: checked
    })
    this.getCalculationInfo()
  }
  useCashDelivery = e => {
    if (this.data.selfPayOnDelivery == 0 && e) {
      this.setData({
        is_self_delivery: false
      })
    }
    this.setData({
      cashOnDelivery: e
    })
    this.getCalculationInfo()
  }
  formSubmit_collect = e => {
    let formid = this.data.formid
    formid.push(e.target.formId)
  }
  saveUserFormId = callback => {
    app.showLoading({
      title: '加载中'
    })
    var that = this
    app.sendRequest({
      url: '/index.php?r=api/AppMsgTpl/saveUserFormId',
      method: 'post',
      data: {
        sub_shop_app_id: that.franchisee_id || '',
        form_id: that.data.formid || []
      },
      complete: function () {
        app.hideLoading()
        callback && callback()
        that.setData({
          formid: []
        })
      }
    })
  }
  addDeliveryImg = () => {
    let that = this
    let a = this.data.additional_info
    let b = this.data.additional_goodsid_arr[0]
    let images = a[b][0].value || []
    app.chooseImage(image => {
      a[b][0].value = images.concat(image)
      that.setData({
        additional_info: a
      })
    }, 9 - a[b][0].value.length)
  }
  deleteImage = e => {
    let that = this
    let a = this.data.additional_info
    let b = this.data.additional_goodsid_arr[0]
    let index = e.currentTarget.dataset.imageIndex
    let images = a[b][0].value
    images.splice(index, 1)
    a[b][0].value = images
    that.setData({
      additional_info: a
    })
  }
  getNoAppointmentWord = () => {
    let a = '商家营业时间：'
    let b = ''
    let businessTimeRule = this.data.businessTimeRule
    businessTimeRule.map(item => {
      for (let i = 0; i < item.business_week.length; i++) {
        if (item.business_week[i] == 1) {
          switch (i) {
            case 0:
              a += '周一、'
              break
            case 1:
              a += '周二、'
              break
            case 2:
              a += '周三、'
              break
            case 3:
              a += '周四、'
              break
            case 4:
              a += '周五、'
              break
            case 5:
              a += '周六、'
              break
            case 6:
              a += '周日、'
              break
          }
        }
      }
      item.business_time_interval.map(item => {
        a += item.start_time + '-' + item.end_time + ' '
      })
    })
    let appointment = this.data.getEcTostoredate.setting_data.appointment
    let advanceInfo = appointment.advance_appointment_info
    switch (advanceInfo.type) {
      case '1':
        b += '无需提前，'
        break
      case '2':
        b += '需提前' + advanceInfo.num + '小时，'
        break
      case '3':
        b += '需提前' + advanceInfo.num + '天，'
        break
    }
    b += '最多可预约' + appointment.valid_days + '天内时间'
    this.setData({
      noAppointmentWorda: a,
      noAppointmentWordb: b
    })
  }
  getPhoneNumber = e => {
    let that = this
    if (/getPhoneNumber:fail/.test(e.target.errMsg)) {
      return
    }
    app.sendRequest({
      url: '/index.php?r=AppUser/GetPhoneNumber',
      data: {
        encryptedData: e.target.encryptedData,
        iv: e.target.iv
      },
      success: function (res) {
        app.setUserInfoStorage({
          phone: res.data
        })
        that.setData({
          phone: res.data
        })
      },
      successStatus5: function () {
        app.showModal({
          content: '获取手机号失败，请再次点击授权获取'
        })
        // app.goLogin({
        //   success: function () {
        //     app.showModal({
        //       content: '获取手机号失败，请再次点击授权获取'
        //     })
        //   },
        //   fail: function () {
        //     app.showModal({
        //       content: '获取手机号失败，请再次点击授权获取'
        //     })
        //   }
        // })
      }
    })
  }
  inputPhone = e => {
    this.setData({
      phone: e.target.value
    })
  }
  hidePerfectAddress = () => {
    this.setData({
      expressAddressNull: false
    })
  }
  getInStoreSeat = () => {
    var that = this
    app.scanCode({
      success: function (res) {
        let path = res.path
        let locationId = path.split(/\?location_id=/)[1]
        app.sendRequest({
          url: '/index.php?r=AppEcommerce/getEcLocationData',
          data: {
            id: locationId,
            sub_shop_app_id: that.franchisee_id
          },
          success: function (res) {
            if (res.data.status == 0) {
              that.setData({
                locationId: locationId,
                inStoreSeatName: res.data.title
              })
            } else {
              app.showModal({
                content: '未检索到座位号'
              })
            }
          }
        })
      },
      fail: function (res) {
        app.showModal({
          content: '未检索到座位号'
        })
      }
    })
  }
  manuallyAddAddress = () => {
    this.isFromSelectAddress = true
    app.turnToPage('/eCommerce/pages/addAddress/addAddress')
  }
  importWeChatAddress = () => {
    let that = this
    app.chooseAddress({
      success: function (res) {
        app.sendRequest({
          method: 'post',
          url: '/index.php?r=AppShop/AddWxAddress',
          data: {
            detailInfo: res.detailInfo || '',
            cityName: res.cityName || '',
            provinceName: res.provinceName || '',
            UserName: res.userName || '',
            telNumber: res.telNumber || '',
            district: res.district || '',
            countyName: res.countyName || ''
          },
          success: function () {
            that.getCalculationInfo()
          }
        })
      }
    })
  }
  selectedPayGift = e => {
    const { detail } = e
    this.setData({
      payGiftOptions: detail.options || {}
    })
    this.getCalculationInfo()
  }

  render() {
    let {
      discountList,
      pickUpTypeArr,
      pickUpType,
      selectAddress,
      selectDelivery,
      selectSameJourney,
      sameJourneyTimeType,
      sameJourneyImmediatlyTime,
      sameJourneyDateTime,
      selfAppointmentSwitch,
      tostoreDateTime,
      tostoreTimeType,
      tostoreOrderType,
      waitingQueueTime,
      tostoreHourTime,
      onlyImmediatlyPickSwitch,
      selfDeliveryPhone,
      phone,
      selfDeliveryScan,
      inStoreSeatName,
      goodsInfo,
      groupType,
      selectmodel,
      goodsPrice,
      goodsIndex,
      num,
      is_group,
      groupPrice,
      selectDiscountInfo,
      selectDiscountIndex,
      discount_price,
      box_fee,
      express_fee,
      useBalance,
      deduction,
      balance,
      settlementActivityFreePrice,
      cashOnDelivery,
      totalPayment,
      canCashDelivery,
      selfPayOnDelivery,
      comment,
      hasRequiredSuppInfo,
      deliverydWrite,
      noAdditionalInfo,
      aloneDeliveryShow,
      additional_info,
      additional_goodsid_arr,
      intraCityData,
      storeStyle,
      isShowPickMask,
      noImmediaPick,
      showImmediatelyTime,
      getEcTostoredate,
      dateIndex,
      tostoreHoursArr,
      noAppointmentShow,
      noAppointmentWordb,
      noAppointmentWorda,
      isShowServiceTime,
      sameJourneyHoursArr,
      isShowSameJourneyTime,
      expressAddressNull
    } = this.state

    // 地址选择之后的回调数据
    let { callbackData } = app.getCurrentPage();
    if (callbackData) {
      selectAddress = callbackData.selectAddress;
      this.state.selectAddress = callbackData.selectAddress;
    } 

    return (
      <React.Fragment>
          <div className="official-page preview-group-order">
            <TopNav title="确认下单"/>
            <div className="preview-group-order-wrap" id="preview-group-order">
              <div className="preview-group-order-section delivery-method-wrap">
                <div
                  className="pick-method"
                  onClick={pickUpTypeArr && pickUpTypeArr.length > 1 ? this.selectPickMethod : null}
                >
                  <div className="pick-method-box">
                    取货方式
                        {pickUpTypeArr && pickUpTypeArr.length > 1 && (
                      <span className="pull-right ico-moon icon-rightarrow"></span>
                    )}
                    <span className="pull-right pick-method-title">
                      {pickUpType == 1
                        ? '快递'
                        : pickUpType == 2
                          ? '同城'
                          : '自提'}
                    </span>
                  </div>
                </div>
                {pickUpType == 1 && (
                  <div className="preview-section">
                    {(selectAddress && selectAddress.id) ? (
                      <React.Fragment>
                        <div
                          className="address-box"
                          onClick={this.goToMyAddress}
                          data-address-id={selectAddress.id}
                        >
                          <span className="ico-moon icon-goods-location"></span>
                          <div className="address-detail">
                            <div className="buyer-name-box">
                              <span className="store-config-label">快递</span>
                              <span className="buyer-name">
                                {selectAddress.address_info.name}
                              </span>
                              <span>{selectAddress.address_info.contact}</span>
                            </div>
                            <div className="buyer-address">
                              {selectAddress.address_info.province.text +
                                selectAddress.address_info.city.text +
                                selectAddress.address_info.district.text +
                                selectAddress.address_info.detailAddress}
                            </div>
                          </div>
                          <div className="ico-moon icon-rightarrow"></div>
                        </div>
                      </React.Fragment>
                    ) : (
                        <React.Fragment>
                          <div
                            className="address-null-box"
                            onClick={this.goToMyAddress}
                          >
                            <div className="pull-right ico-moon icon-rightarrow"></div>
                            <div>
                              <span className="ico-moon icon-goods-location"></span>
                              <span className="add-new-address">新增地址</span>
                            </div>
                          </div>
                        </React.Fragment>
                      )}
                  </div>
                )}
                {pickUpType == 3 && (
                  <div className="preview-section">
                    {selectDelivery.id ? (
                      <React.Fragment>
                        <div
                          className="address-box"
                          onClick={this.toDeliveryList}
                          data-address-id={selectDelivery.id}
                        >
                          <span className="ico-moon icon-goods-location"></span>
                          <div className="address-detail">
                            <div className="buyer-name-box">
                              <span className="store-config-label">自提</span>
                              <span className="buyer-name">
                                {selectDelivery.contact_name}
                              </span>
                              <span>{selectDelivery.service_phone}</span>
                            </div>
                            <div className="buyer-address">
                              {selectDelivery.region_data.region_string +
                                selectDelivery.address_detail}
                            </div>
                          </div>
                          <div className="ico-moon icon-rightarrow"></div>
                        </div>
                      </React.Fragment>
                    ) : (
                        <React.Fragment>
                          <div
                            className="address-null-box"
                            onClick={this.toDeliveryList}
                          >
                            <div className="pull-right ico-moon icon-rightarrow"></div>
                            <div>
                              <span className="ico-moon icon-goods-location"></span>
                              <span className="add-new-address">选择自提点</span>
                            </div>
                          </div>
                        </React.Fragment>
                      )}
                  </div>
                )}
                {pickUpType == 2 && (
                  <div className="preview-section">
                    {selectSameJourney && selectSameJourney.id ? (
                      <React.Fragment>
                        <div
                          className="address-box"
                          onClick={this.goSameJourneyAddress}
                        >
                          <span className="ico-moon icon-goods-location"></span>
                          <div className="address-detail">
                            <div className="buyer-name-box">
                              <span className="store-config-label">同城</span>
                              <span className="buyer-name">
                                {selectSameJourney.address_info.name}
                              </span>
                              <span>
                                {selectSameJourney.address_info.contact}
                              </span>
                            </div>
                            <div className="buyer-address">
                              {selectSameJourney.address_info.province.text +
                                selectSameJourney.address_info.city.text +
                                selectSameJourney.address_info.district.text +
                                selectSameJourney.address_info.detailAddress}
                            </div>
                          </div>
                          <div className="ico-moon icon-rightarrow"></div>
                        </div>
                      </React.Fragment>
                    ) : (
                        <React.Fragment>
                          <div className="address-null-box">
                            <div className="pull-right ico-moon icon-rightarrow"></div>
                            <div onClick={this.goSameJourneyAddress}>
                              <span className="ico-moon icon-goods-location"></span>
                              <span className="add-new-address">
                                选择同城地址
                                </span>
                            </div>
                          </div>
                        </React.Fragment>
                      )}
                  </div>
                )}
                <div className="address-bg">
                  <img src="http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/xcx-goods/goods-address-bg.png" />
                </div>
                {pickUpType == 2 && (
                  <div className="preview-box border-bottom30">
                    <div
                      onClick={this.showSameJourneyTime}
                      className="single-box"
                    >
                      取货时间
                          <div className="pull-right appointment-time-box">
                        <span className="appointment-time">
                          {sameJourneyTimeType == 1
                            ? '尽快送达(预计' +
                            (sameJourneyImmediatlyTime || '') +
                            '分钟后送达)'
                            : sameJourneyDateTime
                              ? '大约' + sameJourneyDateTime + '送达'
                              : '请选择送达时间'}
                        </span>
                        <span className="ico-moon icon-rightarrow"></span>
                      </div>
                    </div>
                  </div>
                )}
                {pickUpType == 3 && (
                  <div className="preview-box border-bottom30">
                    {selfAppointmentSwitch && (
                      <div
                        onClick={this.showServiceTime}
                        className="single-box"
                      >
                        取货时间
                            <div className="pull-right appointment-time-box">
                          {tostoreTimeType == 1 &&
                            tostoreDateTime &&
                            tostoreOrderType == 2 ? (
                              <span className="appointment-time">
                                {dateTrans.date(tostoreDateTime)}
                              </span>
                            ) : tostoreTimeType == 1 && tostoreOrderType == 1 ? (
                              <span className="appointment-time">
                                {waitingQueueTime == 0
                                  ? '立即取货'
                                  : '大约等待' + waitingQueueTime + '分钟'}
                              </span>
                            ) : tostoreTimeType != 1 &&
                              tostoreHourTime &&
                              tostoreOrderType == 2 ? (
                                  <span className="appointment-time">
                                    {dateTrans.date(tostoreDateTime) +
                                      ' ' +
                                      tostoreHourTime}
                                  </span>
                                ) : tostoreTimeType != 1 && tostoreOrderType == 1 ? (
                                  <span className="appointment-time">
                                    {dateTrans.date(tostoreDateTime) +
                                      (waitingQueueTime == 0
                                        ? ' 立即取货'
                                        : '大约等待' + waitingQueueTime + '分钟')}
                                  </span>
                                ) : (
                                    <span className="appointment-time">请选择时间</span>
                                  )}
                          <span className="ico-moon icon-rightarrow"></span>
                        </div>
                      </div>
                    )}
                    {onlyImmediatlyPickSwitch && waitingQueueTime >= 0 && (
                      <div className="single-box">
                        取货时间
                            <div className="pull-right appointment-time-box">
                          <span className="appointment-time">
                            {waitingQueueTime == 0
                              ? '无需等待'
                              : '大约等待' + waitingQueueTime + '分钟'}
                          </span>
                        </div>
                      </div>
                    )}
                    {selfDeliveryPhone == 1 && (
                      <div className="single-box">
                        联系手机号
                            <div className="pull-right input-phone-box phone-number-input">
                          <input
                            type="text"
                            onChange={this.inputPhone}
                            value={phone}
                            placeholder="请输入手机号"
                          />
                          <button
                            className="get-phone-number"
                            onClick={this.getPhoneNumber}
                          >
                            自动授权
                              </button>
                        </div>
                      </div>
                    )}
                    {selfDeliveryScan && (
                      <div
                        className="single-box"
                        onClick={this.getInStoreSeat}
                      >
                        店内位置
                            <div className="pull-right scan-seat-box">
                          <span>{inStoreSeatName || '请扫码获取位置信息'}</span>
                          <span className="ico-moon icon-shopping-scan"></span>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className="preview-group-order-list preview-group-order-section">
                <div className="preview-group-order-item">
                  <img
                    className="preview-goods-cover"
                    src={goodsInfo.cover}
                    mode="aspectFill"
                  />
                  <div className="preview-goods-content">
                    <div className="preview-goods-title">
                      <div>
                        {groupType != 4 ? (
                          <React.Fragment>拼团</React.Fragment>
                        ) : (
                            <React.Fragment>抽奖</React.Fragment>
                          )}
                      </div>
                      {goodsInfo.goods_name}
                    </div>
                    {selectmodel && (
                      <div className="preview-goods-model">
                        {selectmodel == '""' ? '' : selectmodel}
                      </div>
                    )}
                    <div className="preview-quantity-section">
                      {groupType != 4 ? (
                        <React.Fragment>
                          <div style={convertLineStyleData('display:inline-block;')}>
                            <div className="preview-goods-price">
                              {'¥' + goodsInfo.price}
                            </div>
                            <div className="preview-init-price">
                              {'¥' + goodsPrice}
                            </div>
                          </div>
                        </React.Fragment>
                      ) : (
                          <React.Fragment>
                            <div className="preview-goods-price">
                              {'商品价值：¥' + goodsPrice}
                            </div>
                          </React.Fragment>
                        )}
                      {!is_group && (
                        <div className="good-number-box pull-right">
                          <div
                            className="goods-minus"
                            data-index={goodsIndex}
                            onClick={this.clickMinusButton}
                          >
                            -
                              </div>
                          <input
                            className="goods-count"
                            data-index={goodsIndex}
                            type="number"
                            value={num}
                            onChange={this.inputBuyCount}
                          />
                          <div
                            className="goods-plus"
                            data-index={goodsIndex}
                            onClick={this.clickPlusButton}
                          >
                            +
                              </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="preview-group-order-section preview-box">
                <div className="single-box">
                  {groupType != '4' ? (
                    <React.Fragment>
                      商品拼团价
                          <span className="pull-right">{'¥' + groupPrice}</span>
                    </React.Fragment>
                  ) : (
                      <React.Fragment>
                        抽奖金额
                          <span className="pull-right">{'¥' + groupPrice}</span>
                      </React.Fragment>
                    )}
                </div>
                {discountList && !!discountList.length && (
                  <div onClick={this.showMemberDiscount}>
                    <div className="balance-switch">
                      <span>优惠方式</span>
                      <div className="ico-moon icon-rightarrow pull-right"></div>
                      <span className="pull-right select-discount">
                        {selectDiscountInfo.name}
                      </span>
                    </div>
                    <div
                      hidden={selectDiscountIndex == 0}
                      className="balance-price"
                    >
                      <span className="pull-right">
                        {'- ¥' + discount_price}
                      </span>
                    </div>
                  </div>
                )}
                {box_fee != 0 && (
                  <div className="single-box">
                    餐盒费<span className="pull-right">{'¥' + box_fee}</span>
                  </div>
                )}
                <div className="single-box">
                  运费<span className="pull-right">{'¥' + express_fee}</span>
                </div>
                {balance != 0 && (
                  <div>
                    <div className="balance-switch">
                      <span>使用储值金</span>
                      <Switch
                        className="pull-right"
                        style={convertLineStyleData('transform:scale(0.8);')}
                        checked={useBalance}
                        onChange={this.useBalanceChange}
                      ></Switch>
                    </div>
                    <div hidden={!useBalance} className="balance-price">
                      <span className="pull-right">{'- ¥' + deduction}</span>
                    </div>
                  </div>
                )}
                {/* TODO <ComponentPaysettlementgift
                  onSelected={this.selectedPayGift}
                  orderPrice={settlementActivityFreePrice}
                  isShow={!cashOnDelivery}
                ></ComponentPaysettlementgift> */}
                {totalPayment > 0 &&
                  ((pickUpType == 1 && canCashDelivery == 1) ||
                    (pickUpType == 3 && selfPayOnDelivery == 1)) && (
                    <div>
                      <div className="balance-switch">
                        <span>货到付款（先下单，验货后支付）</span>
                        <Switch
                          className="pull-right"
                          onChange={this.useCashDelivery}
                          checked={cashOnDelivery}
                        ></Switch>
                      </div>
                    </div>
                  )}
              </div>
              <div className="preview-box">
                <div className="buyer-message single-box">
                  买家留言
                      <div className="pull-right">
                    <input
                      className="remark"
                      value={comment}
                      onChange={this.commentChange}
                      placeholder="建议留言前先与商家沟通"
                    />
                  </div>
                </div>
                {!noAdditionalInfo && !aloneDeliveryShow && (
                  <div
                    className="border-top1 single-box"
                    onClick={this.goToAdditionalInfo}
                  >
                    补充信息
                        <div className="ico-moon icon-rightarrow pull-right"></div>
                    <span
                      style={convertLineStyleData(
                        'color:' +
                        (hasRequiredSuppInfo && !deliverydWrite
                          ? '#ff7100'
                          : '#666')
                      )}
                      className="additional-tip pull-right"
                    >
                      {deliverydWrite ? '已填写' : '未填写'}
                    </span>
                  </div>
                )}
              </div>
              {aloneDeliveryShow && (
                <React.Fragment>
                  {additional_info[additional_goodsid_arr[0]].map(
                    (item, index) => {
                      return (
                        <div className="additional-list preview-box" key={index}>
                          {item.type == 'text' && (
                            <div className="additional-text">
                              <span
                                className={
                                  'additional-name ' +
                                  (item.is_required == 0 ? 'is-required' : '')
                                }
                              >
                                {item.title}
                              </span>
                              <div className="additional-info">
                                <input
                                  type="text"
                                  onChange={this.inputFormControl}
                                  value={item.value}
                                />
                              </div>
                            </div>
                          )}
                          {item.type == 'mul-text' && (
                            <div className="additional-textarea">
                              <span
                                className={
                                  'additional-name ' +
                                  (item.is_required == 0 ? 'is-required' : '')
                                }
                              >
                                {item.title}
                              </span>
                              <div className="additional-info">
                                <textarea
                                  maxlength="-1"
                                  onChange={this.inputFormControl}
                                  value={item.value}
                                ></textarea>
                              </div>
                            </div>
                          )}
                          {item.type == 'picture' && (
                            <div className="additional-picture">
                              <span
                                className={
                                  'additional-name ' +
                                  (item.is_required == 0 ? 'is-required' : '')
                                }
                              >
                                {item.title}
                              </span>
                              <div className="additional-info">
                                {item.value.map((imgSrc, imageIndex) => {
                                  return (
                                    <div className="image-list" key={imageIndex}>
                                      <img src={imgSrc} />
                                      <label
                                        className="delete-image ico-moon icon-closes"
                                        onClick={this.deleteImage}
                                        data-image-index={imageIndex}
                                      >
                                        -
                                          </label>
                                    </div>
                                  )
                                })}
                                {item.value.length < 9 && (
                                  <div
                                    className="add-images"
                                    onClick={this.addDeliveryImg}
                                  >
                                    <span className="ico-moon icon-goods-add-image"></span>
                                    <div>添加图片</div>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      )
                    }
                  )}
                </React.Fragment>
              )}
              <div className="bottom-nav">
                <div className="preview-goods-total-price">
                  合计:
                      <span className="price-count">
                    ¥<span>{totalPayment}</span>
                  </span>
                </div>
                <form>
                  <button
                    type="button"
                    onClick={this.confirmPayment}>
                    {cashOnDelivery ? '货到付款' : '立即下单'}
                  </button>
                </form>
              </div>
            </div>
            {isShowPickMask && (
              <div className="goods-pick-mask">
                <div className="goods-pick-box">
                  <div className="goods-pick-header">更换取货方式</div>
                  <div className="goods-pick-content">
                    {pickUpTypeArr.map((item, index) => {
                      return (
                        <div key={index} className="goods-pick-menu">
                          <div
                            className={
                              'pick-detail ' +
                              (item == 2 &&
                                (intraCityData.is_enough_price != 1 ||
                                  intraCityData.in_business_time != 1)
                                ? 'no-achieve-price-box'
                                : '')
                            }
                          >
                            <div className="pick-style">
                              {item == 1
                                ? '快递'
                                : item == 2
                                  ? '同城配送'
                                  : '上门自提'}
                            </div>
                            {item == 2 && intraCityData.in_business_time != 1 ? (
                              <div className="no-achieve-price">不在营业时间</div>
                            ) : (
                                item == 2 &&
                                intraCityData.is_enough_price != 1 && (
                                  <div className="no-achieve-price">
                                    {'未达到起送价 还差' +
                                      intraCityData.min_deliver_price_balance +
                                      '元'}
                                  </div>
                                )
                              )}
                          </div>
                          <div className="pick-btn-box">
                            <span
                              style={convertLineStyleData(
                                item != 2 ||
                                  (intraCityData.is_enough_price == 1 &&
                                    intraCityData.in_business_time == 1)
                                  ? 'color:#ff7100;border-color:#ff7100' +
                                  (storeStyle && storeStyle.theme)
                                  : 'color: #D2D2D2;border-color: #D2D2D2'
                              )}
                              onClick={
                                item != 2 ||
                                  (intraCityData.is_enough_price == 1 &&
                                    intraCityData.in_business_time == 1)
                                  ? this.deliveryWayChange
                                  : null
                              }
                              data-type={item}
                            >
                              选择
                            </span>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                  <div className="goods-pick-bottom" onClick={this.closeGoodsPick}>
                    关闭
                  </div>
                </div>
              </div>
            )}
            {isShowServiceTime && (
              <div className="goods-pick-mask">
                <div className="goods-pick-box">
                  <div className="goods-pick-header">选择取货时间</div>
                  {!noAppointmentShow ? (
                    <React.Fragment>
                      {tostoreTimeType == 1 && (
                        <div className="goods-pick-content">
                          {noImmediaPick && showImmediatelyTime && (
                            <div
                              onClick={this.tostoreImmediately}
                              className={
                                'goods-pick-time ' +
                                (tostoreOrderType == 1 ? 'selected' : '')
                              }
                            >
                              {'立即取货（' +
                                (waitingQueueTime == 0
                                  ? '无需等待'
                                  : '大约等待' + waitingQueueTime + '分钟') +
                                '）'}
                            </div>
                          )}
                          {getEcTostoredate.date_arr.map((item, index) => {
                            return (
                              <React.Fragment key={index}>
                                {item.is_vaild == 1 && (
                                  <div
                                    onClick={this.selectTostoreTime}
                                    data-index={index}
                                    className={
                                      'goods-pick-time ' +
                                      (tostoreOrderType != 1 &&
                                        tostoreDateTime == item.date
                                        ? 'selected'
                                        : '')
                                    }
                                  >
                                    {dateTrans.date(item.date) +
                                      '(星期' +
                                      dateTrans.week(item.week) +
                                      ')'}
                                  </div>
                                )}
                              </React.Fragment>
                            )
                          })}
                        </div>
                      )}
                      {getEcTostoredate.setting_data && tostoreTimeType != 1 && (
                        <div className="double-column-time">
                          <div className="double-time-day">
                            {getEcTostoredate.date_arr.map((item, index) => {
                              return (
                                <React.Fragment key={index}>
                                  {item.is_vaild == 1 && (
                                    <div
                                      onClick={this.selectTostoreTime}
                                      data-index={index}
                                      className={
                                        'goods-pick-time ' +
                                        (tostoreDateTime == item.date
                                          ? 'selected'
                                          : '')
                                      }
                                    >
                                      {dateTrans.date(item.date) +
                                        '(星期' +
                                        dateTrans.week(item.week) +
                                        ')'}
                                    </div>
                                  )}
                                </React.Fragment>
                              )
                            })}
                          </div>
                          <div className="double-time-hours">
                            {!dateIndex && showImmediatelyTime && noImmediaPick && (
                              <div
                                onClick={this.tostoreImmediately}
                                className={
                                  'goods-pick-time ' +
                                  (tostoreOrderType == 1 ? 'selected' : '')
                                }
                              >
                                {'立即取货（' +
                                  (waitingQueueTime == 0
                                    ? '无需等待'
                                    : '大约等待' + waitingQueueTime + '分钟') +
                                  '）'}
                              </div>
                            )}
                            {tostoreHoursArr && tostoreHoursArr.map((item, index) => {
                              return (
                                <div
                                  onClick={this.selectTostoreHourTime}
                                  data-index={index}
                                  className={
                                    tostoreHourTime == item ? 'selected' : ''
                                  }
                                  key={index}
                                >
                                  {item}
                                </div>
                              )
                            })}
                          </div>
                        </div>
                      )}
                    </React.Fragment>
                  ) : (
                      <div className="none-appointment-time">
                        <img
                          className="no-reservation"
                          src="http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/no-reservation.png"
                        />
                        <div className="title">暂无可预约时间</div>
                        <div className="tips">{noAppointmentWordb}</div>
                        <div className="tips">{noAppointmentWorda}</div>
                      </div>
                    )}
                  <div className="goods-pick-bottom" onClick={this.closeGoodsPick}>
                    关闭
                  </div>
                </div>
              </div>
            )}
            {isShowSameJourneyTime && (
              <div className="goods-pick-mask">
                <div className="goods-pick-box">
                  <div className="goods-pick-header">选择送达时间</div>
                  <div className="goods-pick-content goods-same-journey-time">
                    <div
                      onClick={this.selectSameJourneyTime}
                      data-type="immedia"
                      className={
                        'goods-pick-time ' +
                        (sameJourneyTimeType == 1 ? 'selected' : '')
                      }
                    >
                      {'尽快送达(预计' + sameJourneyImmediatlyTime + '分钟后送达)'}
                    </div>
                    {sameJourneyHoursArr.map((item, index) => {
                      return (
                        <React.Fragment key={index}>
                          <div
                            onClick={this.selectSameJourneyTime}
                            data-type="appoint"
                            data-index={index}
                            className={
                              'goods-pick-time ' +
                              (sameJourneyTimeType != 1 &&
                                sameJourneyDateTime == item
                                ? 'selected'
                                : '')
                            }
                          >
                            {item}
                          </div>
                        </React.Fragment>
                      )
                    })}
                  </div>
                  <div className="goods-pick-bottom" onClick={this.closeGoodsPick}>
                    关闭
                  </div>
                </div>
              </div>
            )}
            {expressAddressNull && (
              <div
                className="perfect-address-mask"
                onClick={this.hidePerfectAddress}
              >
                <div className="perfect-address-box">
                  <div className="perfect-address-title">提示</div>
                  <div className="perfect-address-tips">请完善地址信息~</div>
                  <div className="perfect-address-bottom">
                    <span onClick={this.manuallyAddAddress}>手动新增地址</span>
                    <span
                      onClick={this.importWeChatAddress}
                      className="import-weChat-address"
                    >
                      导入微信地址
                    </span>
                  </div>
                </div>
              </div>
            )}
        </div>
        <MemberDiscount ref={this.memberDiscountRef} />
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/preview-group-order/PreviewGroupOrder.jsx